import { mountTawkWidgetInShell, unmountTawkWidgetFromShell } from './positionTawkWidget'

const CHAT_OPEN_ATTR = 'data-tawk-chat-open'

// Becomes true once Tawk's onLoad has fired — used to gate the launcher button.
let _tawkLoaded = false
export const isTawkLoaded  = (): boolean => _tawkLoaded
export const markTawkLoaded = (): void => {
  _tawkLoaded = true
  window.dispatchEvent(new CustomEvent('tipsterizer-tawk-ready'))
}

/** User explicitly opened chat (launcher click). Not inferred from iframe size. */
export const isTawkChatSessionOpen = (): boolean =>
  document.body.hasAttribute(CHAT_OPEN_ATTR)

export const setTawkChatSessionOpen = (open: boolean): void => {
  if (open) {
    document.body.setAttribute(CHAT_OPEN_ATTR, 'true')
    window.dispatchEvent(new CustomEvent('tipsterizer-tawk-chat-opened'))
  } else {
    document.body.removeAttribute(CHAT_OPEN_ATTR)
    closeTawkChat()
    window.dispatchEvent(new CustomEvent('tipsterizer-tawk-chat-closed'))
  }
}

/** Open or restore the maximized tawk chat (same session if still active). */
export const openTawkSupportChat = (): void => {
  const api = window.Tawk_API
  if (!api) return

  api.showWidget?.()

  let attempts = 0
  const openWhenReady = (): void => {
    if (!document.getElementById('max-widget')) {
      attempts += 1
      if (attempts < 40) {
        window.setTimeout(openWhenReady, 50)
      }
      return
    }

    // Set the attribute BEFORE maximize so that onChatMaximized (in SupportChatProvider)
    // sees it as true and mounts the widget instead of calling hideWidget.
    document.body.setAttribute(CHAT_OPEN_ATTR, 'true')
    window.dispatchEvent(new CustomEvent('tipsterizer-tawk-chat-opened'))

    if (typeof api.maximize === 'function') api.maximize()
    else api.toggle?.()

    window.requestAnimationFrame(() => {
      mountTawkWidgetInShell()
      // Re-apply at multiple intervals — on taller/wider screens (e.g. iPhone 16
      // Pro Max) Tawk may apply additional layout resets later than on SE.
      window.setTimeout(() => mountTawkWidgetInShell(), 80)
      window.setTimeout(() => mountTawkWidgetInShell(), 200)
      window.setTimeout(() => mountTawkWidgetInShell(), 400)
    })
  }

  openWhenReady()
}

// Guard against the close feedback loop:
//   onChatMinimized → setTawkChatSessionOpen(false) → closeTawkChat() → api.minimize()
//   → onChatMinimized → … (infinite)
// With the guard, the second call to closeTawkChat() returns early.
let _closingChat = false

/** Close / minimize the chat and hide tawk chrome (custom launcher stays). */
export const closeTawkChat = (): void => {
  if (_closingChat) {
    console.info('[tawk-shell] closeTawkChat skipped (guard active)')
    return
  }
  _closingChat = true
  console.info('[tawk-shell] closeTawkChat: starting')

  const api = window.Tawk_API
  if (api) {
    if (typeof api.minimize === 'function') api.minimize()
    api.hideWidget?.()
  }
  unmountTawkWidgetFromShell()

  // Reset the guard after enough time for Tawk's callback chain to settle.
  window.setTimeout(() => { _closingChat = false }, 500)
}
